import React from 'react';
import {Link, useParams} from 'react-router-dom';
import {type ProjectType} from 'api/generated';
import {formatDistanceToNowStrict} from 'date-fns';
import {Dropdown} from 'components';
import {imgNone} from 'assets';

import {ClockIcon, CubeIcon, UserIcon, UsersIcon} from '@heroicons/react/24/outline';
import {PencilSquareIcon, TrashIcon} from '@heroicons/react/20/solid';

interface IProjectsItemProps {
  project: ProjectType;
  onDelete: (uid: string) => void;
}

const ProjectsItem = ({project, onDelete}: IProjectsItemProps) => {
  const params = useParams();
  const workspace = params.workspace ?? '';

  const dropdownItems = [
    [
      {icon: PencilSquareIcon, text: 'Edit', path: `/${workspace}/projects/${project.uid}`},
      // {icon: DocumentDuplicateIcon, text: 'Duplicate', path: `/${workspace}/projects/${project.uid}`},
    ],
    // [
    //   {icon: ArchiveBoxIcon, text: 'Archive', path: `/${workspace}/projects/${project.uid}`},
    //   {icon: ArrowRightCircleIcon, text: 'Move', path: `/${workspace}/projects/${project.uid}`},
    // ],
    // [
    //   {icon: UserPlusIcon, text: 'Share', path: `/${workspace}/projects/${project.uid}`},
    //   {icon: HeartIcon, text: 'Add to favorites', path: `/${workspace}/projects/${project.uid}`},
    // ],
    ...(project.isMine ? [[{icon: TrashIcon, text: 'Delete', onClick: () => onDelete(project.uid), color: 'text-red-500'}]] : []),
  ];

  return (
    <li className="flex">
      <img
        src={imgNone}
        alt={project.slug}
        className="w-24 sm:w-32 aspect-square object-cover shrink-0 rounded-l-md border-t border-l border-b border-slate-200 dark:border-slate-500 object-cover"
      />
      <div className="min-h-24 flex flex-1 items-center justify-between rounded-r-md border-t border-r border-b border-slate-200 dark:border-slate-500 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700">
        <Link to={`/${workspace}/projects/${project.uid}`} className="w-full">
          <div className="flex flex-col items-start px-4 py-2 text-sm">
            <p className="font-medium line-clamp-2 text-base sm:text-lg text-slate-800 dark:text-white">{project.name}</p>
            <div className="flex flex-col sm:flex-row sm:items-center gap-2 mt-2.5 text-xs text-slate-500 dark:text-slate-400">
              <div className="flex items-center gap-1">
                <div className="flex items-center gap-1">
                  <CubeIcon className="size-4" />
                  <p>
                    {project.meshesCount} <span className="hidden sm:inline-block">Models</span>
                  </p>
                </div>
                <p>•</p>
                <div className="flex items-center gap-1">
                  <UsersIcon className="size-4" />
                  <p>
                    {project.membersCount} <span className="hidden sm:inline-block">Members</span>
                  </p>
                </div>
                <p className="hidden sm:block">•</p>
              </div>
              <p className="flex items-center gap-1">
                <ClockIcon className="size-4" />
                Updated {formatDistanceToNowStrict(new Date(project.updatedAt!), {addSuffix: true})}
              </p>
            </div>
            <div className="flex items-center gap-1 mt-2 sm:mt-3">
              <UserIcon className="size-4" />
              <p className="text-xs text-slate-500 dark:text-slate-400">
                <span className="inline-block sm:hidden">By </span>
                <span className="hidden sm:inline-block">Created by </span> {project.creatorName}
              </p>
            </div>
          </div>
        </Link>
        <div className="shrink-0 pr-2">
          <Dropdown items={dropdownItems} />
        </div>
      </div>
    </li>
  );
};

export default React.memo(ProjectsItem);
